import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import 'react-quill/dist/quill.bubble.css';

type TextAreaQuillProps = {
  theme: string;
  bounds: string;
  placeholder: string;
  value?: any;
  onChange?: (content: any, delta: any, source: any, editor: any) => void;
  onKeyDown?: (event: React.EventHandler<any>) => void;
  onKeyUp?: (event: React.EventHandler<any>) => void;
  readOnly?: boolean;
};

const toolbarOptions = [
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  ['bold', 'italic', 'underline', 'strike'], // toggled buttons
  ['blockquote'],
  // [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: 'ordered' }, { list: 'bullet' }],
  // [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
  // [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
  // [{ direction: 'rtl' }], // text direction
  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ size: ['small', 'normal', 'large', 'huge'] }], // custom dropdown
  ['link', 'image', 'video'],
  // [{ font: [] }],
  // [{ align: [] }],

  ['clean'], // remove formatting button
];

export const TextAreaQuill = (props: TextAreaQuillProps) => {
  return <ReactQuill {...props} modules={{ toolbar: toolbarOptions }} />;
};
